import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { ActivityArea } from "../../core/model/activity-area";
import { ActivityAreaService } from "../../core/service/activity-area.service";

@Component({
  selector: "app-add-activity-area",
  templateUrl: "./add-activity-area.component.html",
  styleUrls: ["./add-activity-area.component.scss"],
})
export class AddActivityAreaComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  activityArea: ActivityArea = new ActivityArea();

  constructor(
    private _router: Router,
    private _activityAreaService: ActivityAreaService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(20)],
      ],
      label: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(50)],
      ],
    });
  }

  ngOnInit() {}

  save(): void {
    this._activityAreaService
      .add(this.activityArea)
      .pipe(first())
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/activity-area");
  }
}
